import { render, staticRenderFns } from "./ContentTypeUsersModal.vue?vue&type=template&id=0b2aa418&"
import script from "./ContentTypeUsersModal.vue?vue&type=script&lang=ts&"
export * from "./ContentTypeUsersModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports